// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__mIMPn","openButton":"styles_openButton__FKdki","rotated":"styles_rotated__0Kjra","readOnly":"styles_readOnly__kjH4h"};